import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { createBrowserHistory } from "history";
export const history = createBrowserHistory();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
